import { render } from "./TaskDetailView.vue?vue&type=template&id=231d53ca&scoped=true"
import script from "./TaskDetailView.vue?vue&type=script&lang=js"
export * from "./TaskDetailView.vue?vue&type=script&lang=js"

import "./TaskDetailView.vue?vue&type=style&index=0&id=231d53ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231d53ca"]])

export default __exports__